import { Flower2, Camera, Wrench, Car, PawPrint, Sparkles, GraduationCap, Smartphone, Package, Truck } from "lucide-react";

// Category IDs (stable) — must match backend /api/meta
export const CATEGORIES = [
  "flowers_gifts",
  "events_photography",
  "home_services",
  "car_services",
  "pets",
  "beauty_care",
  "lessons_training",
  "phones_electronics",
  "custom_requests",
  "moving_transport",
];

export const CATEGORY_ICONS = {
  flowers_gifts: Flower2,
  events_photography: Camera,
  home_services: Wrench,
  car_services: Car,
  pets: PawPrint,
  beauty_care: Sparkles,
  lessons_training: GraduationCap,
  phones_electronics: Smartphone,
  custom_requests: Package,
  moving_transport: Truck,
};

// Taxonomy (Arabic canonical values — must match backend):
//   preview    — up to five activities shown on the homepage (may include grouping labels)
//   full       — the complete activity list (expanded view, request form, merchant onboarding)
//   previewMap — homepage grouping labels -> the specific full activities they represent
export const TAXONOMY = {
  home_services: {
    preview: ["صيانة وتركيب المكيفات", "سباكة", "كهرباء منازل", "تنظيف منازل", "صيانة أجهزة منزلية"],
    full: [
      "صيانة وتركيب المكيفات", "تنظيف وغسيل المكيفات", "سباكة", "كهرباء منازل", "صيانة أجهزة منزلية",
      "صيانة ثلاجات وفريزرات", "صيانة غسالات ونشافات", "صيانة أفران وطباخات", "تنظيف منازل", "تنظيف عميق",
      "تنظيف كنب وسجاد", "تنظيف خزانات مياه", "مكافحة حشرات", "كشف تسربات المياه", "نجارة وتركيب أثاث",
      "تركيب أجهزة منزلية", "دهان وورق جدران", "جبس وديكور داخلي", "تركيب ستائر", "حدادة وألمنيوم",
      "تركيب زجاج ومرايا", "تنسيق وصيانة الحدائق", "صيانة عامة", "خدمات منزلية أخرى",
    ],
    previewMap: {},
  },
  car_services: {
    preview: ["بنشر متنقل", "بطاريات متنقلة", "فحص وتشخيص الأعطال", "ميكانيكا سيارات", "سطحة وسحب سيارات"],
    full: [
      "بنشر متنقل", "إصلاح وتغيير الإطارات", "بطاريات متنقلة", "اشتراك وتشغيل البطارية", "تغيير الزيت والفلاتر",
      "فحص وتشخيص الأعطال", "فحص كمبيوتر السيارات", "ميكانيكا سيارات", "كهرباء سيارات", "صيانة تكييف السيارات",
      "غسيل سيارات", "تلميع وتنظيف داخلي", "حماية وتلميع الطلاء", "تظليل سيارات", "سمكرة ودهان",
      "سطحة وسحب سيارات", "برمجة مفاتيح السيارات", "تركيب إكسسوارات السيارات", "فحص السيارة قبل الشراء",
    ],
    previewMap: {},
  },
  beauty_care: {
    preview: ["مكياج", "تصفيف وتسريحات الشعر", "مانيكير وباديكير", "رموش وحواجب", "عناية بالبشرة"],
    full: [
      "مكياج", "مكياج مناسبات", "تجهيز العرائس", "تصفيف وتسريحات الشعر", "قص الشعر", "صبغات وتلوين الشعر",
      "علاجات الشعر", "استشوار", "مانيكير", "باديكير", "جل وأكريليك للأظافر", "تصميم وزينة الأظافر",
      "تركيب رموش", "رفع الرموش", "تنسيق وصبغ الحواجب", "عناية وتنظيف البشرة", "إزالة الشعر", "حناء ونقش",
      "مساج واسترخاء غير طبي",
    ],
    previewMap: {
      "مانيكير وباديكير": ["مانيكير", "باديكير"],
      "رموش وحواجب": ["تركيب رموش", "رفع الرموش", "تنسيق وصبغ الحواجب"],
      "عناية بالبشرة": ["عناية وتنظيف البشرة"],
    },
  },
  events_photography: {
    preview: ["تصوير مناسبات", "تصوير فيديو", "تنسيق مناسبات", "ديكور وتجهيز", "ضيافة قهوة وشاي"],
    full: [
      "تصوير مناسبات", "تصوير حفلات زفاف", "تصوير منتجات", "تصوير فيديو", "مونتاج فيديو",
      "تنسيق وإدارة المناسبات", "ديكور وتجهيز المناسبات", "تجهيز كوش الأفراح", "تنسيق بالونات",
      "ضيافة قهوة وشاي", "قهوجيون وصبابون", "بوفيه وضيافة", "صوت وإضاءة", "تأجير طاولات وكراسي",
      "تأجير مستلزمات المناسبات", "دي جي وترفيه للمناسبات", "بث مباشر للمناسبات", "طباعة دعوات ولوحات",
    ],
    previewMap: {
      "تنسيق مناسبات": ["تنسيق وإدارة المناسبات"],
      "ديكور وتجهيز": ["ديكور وتجهيز المناسبات"],
    },
  },
  flowers_gifts: {
    preview: ["باقات زهور", "تنسيق زهور", "بوكسات هدايا", "تغليف هدايا", "شوكولاتة وحلويات"],
    full: [
      "باقات زهور", "تنسيق زهور", "زهور في مزهريات", "زهور للمناسبات", "بوكسات هدايا جاهزة",
      "تجهيز بوكس هدايا حسب المناسبة", "تغليف هدايا", "شوكولاتة وحلويات", "كيك وحلويات للمناسبات", "عطور",
      "بخور وفواحات", "شموع", "نباتات وهدايا نباتية", "هدايا مواليد", "هدايا تخرج", "هدايا شركات",
    ],
    previewMap: {
      "بوكسات هدايا": ["بوكسات هدايا جاهزة", "تجهيز بوكس هدايا حسب المناسبة"],
    },
  },
  phones_electronics: {
    preview: ["صيانة جوالات", "استبدال شاشات الجوال", "استبدال بطاريات الجوال", "صيانة أجهزة الحاسب واللابتوب", "صيانة أجهزة الألعاب"],
    full: [
      "صيانة جوالات", "استبدال شاشات الجوال", "استبدال بطاريات الجوال", "إصلاح منافذ الشحن",
      "إصلاح الكاميرا والسماعة", "استعادة بيانات الجوال", "صيانة الأجهزة اللوحية", "صيانة أجهزة الحاسب المكتبي",
      "صيانة اللابتوب", "تثبيت الأنظمة والبرامج", "إزالة الفيروسات والبرامج الضارة", "استعادة البيانات",
      "صيانة أجهزة الألعاب", "صيانة التلفزيونات والشاشات", "صيانة الكاميرات", "إعداد الشبكات والواي فاي",
      "تركيب كاميرات المراقبة", "تركيب أنظمة المنزل الذكي",
    ],
    previewMap: {
      "صيانة أجهزة الحاسب واللابتوب": ["صيانة أجهزة الحاسب المكتبي", "صيانة اللابتوب"],
    },
  },
  moving_transport: {
    preview: ["نقل أثاث", "فك وتركيب الأثاث", "نقل بضائع", "توصيل داخل المدينة", "شحن بين المدن"],
    full: [
      "نقل أثاث", "فك وتركيب الأثاث", "تغليف الأثاث", "نقل المكاتب والشركات", "نقل الأجهزة والمعدات",
      "نقل البضائع", "توصيل داخل المدينة", "شحن بين المدن", "نقل مبرد", "تخزين مؤقت",
      "توصيل طلبات المتاجر", "نقل الدراجات النارية", "نقل السيارات",
    ],
    previewMap: {
      "نقل بضائع": ["نقل البضائع"],
    },
  },
  lessons_training: {
    preview: ["دروس مدرسية", "قدرات وتحصيلي", "تعليم اللغات", "دروس جامعية", "تدريب رياضي شخصي"],
    full: [
      "دروس المرحلة الابتدائية", "دروس المرحلة المتوسطة", "دروس المرحلة الثانوية", "التحضير لاختبار القدرات",
      "التحضير للاختبار التحصيلي", "تعليم اللغة الإنجليزية", "تعليم اللغة العربية", "تعليم لغات أخرى",
      "التحضير لاختبار IELTS", "التحضير لاختبار TOEFL", "دروس جامعية", "مساعدة في الواجبات",
      "تعليم الحاسب", "برمجة للمبتدئين", "دروس موسيقى", "تدريب رياضي شخصي", "تدريب مهني ومهاري", "تدريب عن بُعد",
    ],
    previewMap: {
      "دروس مدرسية": ["دروس المرحلة الابتدائية", "دروس المرحلة المتوسطة", "دروس المرحلة الثانوية"],
      "قدرات وتحصيلي": ["التحضير لاختبار القدرات", "التحضير للاختبار التحصيلي"],
      "تعليم اللغات": ["تعليم اللغة الإنجليزية", "تعليم اللغة العربية", "تعليم لغات أخرى"],
    },
  },
  custom_requests: {
    preview: ["كيك حسب الطلب", "هدايا مخصصة", "طباعة حسب الطلب", "تطريز حسب الطلب", "حفر ونقش بالليزر"],
    full: [
      "كيك حسب الطلب", "حلويات حسب الطلب", "هدايا مخصصة", "بوكسات مخصصة", "توزيعات مخصصة",
      "طباعة حسب الطلب", "طباعة الملابس", "طباعة الأكواب والمنتجات", "تطريز حسب الطلب", "حفر ونقش بالليزر",
      "تصميم وطباعة الدعوات", "بطاقات مخصصة", "لوحات ولافتات", "استيكرات وملصقات", "تغليف وتعبئة مخصصة",
      "تصميم جرافيك", "مجسمات ومنتجات يدوية", "نجارة حسب الطلب", "تفصيل الستائر والمفروشات",
    ],
    previewMap: {},
  },
  pets: {
    preview: ["عناية وتجميل الحيوانات", "استضافة الحيوانات", "رعاية منزلية", "خدمات بيطرية", "نقل الحيوانات الأليفة"],
    full: [
      "عناية وتجميل الحيوانات الأليفة", "استحمام وتنظيف الحيوانات الأليفة", "قص الشعر والأظافر",
      "استضافة الحيوانات الأليفة", "حضانة نهارية للحيوانات الأليفة", "رعاية منزلية للحيوانات الأليفة",
      "زيارة ورعاية الحيوانات أثناء السفر", "تمشية الكلاب", "تدريب الحيوانات الأليفة", "نقل الحيوانات الأليفة",
      "خدمات بيطرية", "تطعيمات وفحوصات بيطرية", "مستلزمات الحيوانات الأليفة",
    ],
    previewMap: {
      "عناية وتجميل الحيوانات": ["عناية وتجميل الحيوانات الأليفة"],
      "استضافة الحيوانات": ["استضافة الحيوانات الأليفة"],
      "رعاية منزلية": ["رعاية منزلية للحيوانات الأليفة"],
    },
  },
};

// Convenience views
export const PREVIEW_ACTIVITIES = Object.fromEntries(CATEGORIES.map((c) => [c, TAXONOMY[c].preview]));
export const FULL_ACTIVITIES = Object.fromEntries(CATEGORIES.map((c) => [c, TAXONOMY[c].full]));

// "Other" catch-all — home_services ONLY (always the final option)
export const OTHER_HOME_ACTIVITY = "خدمات منزلية أخرى";

// Activities requiring manual license verification — never auto-activated
export const VET_ACTIVITIES = ["خدمات بيطرية", "تطعيمات وفحوصات بيطرية"];

// Commercial transport/delivery activities that support document verification
export const TRANSPORT_DOC_ACTIVITIES = [
  "نقل المكاتب والشركات", "نقل البضائع", "توصيل داخل المدينة", "شحن بين المدن",
  "نقل مبرد", "توصيل طلبات المتاجر", "نقل السيارات",
];

export const SERVICE_METHODS = ["في موقع العميل", "في موقع مزود الخدمة", "استلام وتسليم", "عن بُعد", "حسب الاتفاق"];
export const MERCHANT_TYPES = ["فرد مستقل", "مؤسسة", "شركة", "متجر", "صالون", "عيادة", "مركز تدريب"];

export const MAX_MERCHANT_CATEGORIES = 2;

export const CITIES = ["riyadh", "jeddah", "dammam", "khobar", "makkah", "madinah", "other"];

// Districts per city (Arabic canonical values — must match backend)
export const DISTRICTS = {
  riyadh: ["الملقا", "النرجس", "الياسمين", "العقيق", "الصحافة", "حطين", "الملز", "العليا", "السليمانية", "الروضة", "النسيم", "الربوة", "المروج", "قرطبة", "اليرموك", "الرمال", "الشفا", "العزيزية", "لبن", "ظهرة لبن", "النخيل", "الواحة", "المونسية", "إشبيليا", "غرناطة", "الحمراء", "الخليج", "السويدي", "الدار البيضاء", "طويق", "أخرى"],
  jeddah: ["الحمراء", "الروضة", "السلامة", "الزهراء", "النعيم", "الصفا", "المروة", "الفيصلية", "البوادي", "النهضة", "الشاطئ", "أبحر الشمالية", "أبحر الجنوبية", "الرحاب", "المرجان", "النزهة", "البساتين", "الأندلس", "العزيزية", "الربوة", "الخالدية", "السامر", "الحمدانية", "بني مالك", "أخرى"],
  dammam: ["الشاطئ", "الفيصلية", "الريان", "النور", "النهضة", "الجلوية", "الأثير", "الروضة", "طيبة", "الفردوس", "المزروعية", "الضباب", "عبدالله فؤاد", "أحد", "الندى", "الصدفة", "الأمانة", "الإسكان", "أخرى"],
  khobar: ["العقربية", "الثقبة", "الحزام الذهبي", "الراكة", "العليا", "الجسر", "الخبر الشمالية", "الخبر الجنوبية", "الحمراء", "البندرية", "التحلية", "اليرموك", "الكورنيش", "العزيزية", "أخرى"],
  makkah: ["العزيزية", "الشوقية", "العوالي", "النسيم", "الزاهر", "الرصيفة", "بطحاء قريش", "الكعكية", "الششة", "العتيبية", "جرول", "المسفلة", "النزهة", "الحمراء", "أخرى"],
  madinah: ["العزيزية", "قباء", "العوالي", "الحرة الشرقية", "الحرة الغربية", "النبلاء", "الملك فهد", "شوران", "القبلتين", "الدفاع", "العنابس", "بني حارثة", "الرانوناء", "أخرى"],
  other: [],
};

export const SUPPORT_EMAIL = "support@hustlersksa.com";
